import { render, staticRenderFns } from "./LoadingComponent.html?vue&type=template&id=71fdca6c&scoped=true&"
import script from "./LoadingComponent.js?vue&type=script&lang=js&"
export * from "./LoadingComponent.js?vue&type=script&lang=js&"
import style0 from "./LoadingComponent.scss?vue&type=style&index=0&id=71fdca6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fdca6c",
  null
  
)

export default component.exports